import React from "react";
import {
  EmployeeRecordCacheContext,
  useEmployeeRecordCacheState,
} from "../../hooks/useEmployeeRecordCache";

interface EmployeeRecordCacheProviderProps {
  children: React.ReactNode;
}

export const EmployeeRecordCacheProvider: React.FC<EmployeeRecordCacheProviderProps> = ({
  children,
}) => {
  const cacheState = useEmployeeRecordCacheState();

  return (
    <EmployeeRecordCacheContext.Provider value={cacheState}>
      {children}
    </EmployeeRecordCacheContext.Provider>
  );
};

